import React, { forwardRef, useImperativeHandle, useRef } from "react";
import html2pdf from "html2pdf.js";

const DownloadPdf = forwardRef(({ results }, ref) => {
  const pdfRef = useRef();

  useImperativeHandle(ref, () => ({
    download: () => {
      if (!results) return;

      const opt = {
        margin: 0.5,
        filename: `calculation-${Date.now()}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };

      html2pdf().set(opt).from(pdfRef.current).save();
    },
  }));

  if (!results) return null;

  return (
    <div style={{ position: "absolute", left: "-9999px" }}>
      <div ref={pdfRef} style={containerStyle}>
        {/* Header */}
        <div style={headerStyle}>
          <h1 style={titleStyle}>Calculation Summary</h1>
        </div>

        {/* Info Section */}
        <div style={infoContainer}>
          <div style={infoBox}>
            <span style={label}>Plant</span>
            <span style={value}>{results.plant.plantName}</span>
          </div>

          <div style={infoBox}>
            <span style={label}>Grade</span>
            <span style={value}>{results.mixture.gradeName}</span>
          </div>
        </div>

        {/* Table */}
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Product</th>
              <th style={thStyle}>Variety</th>
              <th style={thStyle}>Quantity</th>
              <th style={thStyle}>Price / Unit</th>
              <th style={thStyle}>Total Cost</th>
            </tr>
          </thead>

          <tbody>
            {results.rows.map((row, idx) => (
              <tr key={idx} style={idx % 2 === 0 ? rowEven : rowOdd}>
                <td style={tdStyle}>{row.name}</td>
                <td style={tdStyle}>{row.varietyName}</td>
                <td style={tdStyle}>
                  {row.quantity} {row.unit}
                </td>
                <td style={tdStyle}>₹ {row.pricePerUnit}</td>
                <td style={tdStyle}>₹ {row.cost}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Total Section */}
        <div style={totalContainer}>
          <span style={totalLabel}>Total Cost</span>
          <span style={totalValue}>₹ {results.totalCost}</span>
        </div>

        {/* Footer */}
        <div style={footer}>
          <p>Date • {new Date().toLocaleDateString()}</p>
        </div>
      </div>
    </div>
  );
});

/* ================= STYLES ================= */

const containerStyle = {
  fontFamily: "Arial, sans-serif",
  padding: "30px",
  background: "#ffffff",
  color: "#333",
  width: "100%",
};

/* Header */
const headerStyle = {
  borderBottom: "2px solid #eee",
  marginBottom: "20px",
  paddingBottom: "10px",
};

const titleStyle = {
  margin: 0,
  fontSize: "24px",
  fontWeight: "600",
};

const subTitleStyle = {
  margin: "5px 0 0",
  color: "#777",
  fontSize: "12px",
};

/* Info Section */
const infoContainer = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "20px",
};

const infoBox = {
  display: "flex",
  flexDirection: "column",
};

const label = {
  fontSize: "12px",
  color: "#888",
  marginBottom: "4px",
};

const value = {
  fontSize: "14px",
  fontWeight: "600",
};

/* Table */
const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "10px",
};

const thStyle = {
  borderBottom: "2px solid #ddd",
  padding: "10px",
  textAlign: "left",
  fontSize: "13px",
  background: "#fafafa",
};

const tdStyle = {
  padding: "10px",
  fontSize: "13px",
  borderBottom: "1px solid #eee",
};

const rowEven = {
  background: "#ffffff",
};

const rowOdd = {
  background: "#fcfcfc",
};

/* Total */
const totalContainer = {
  marginTop: "25px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderTop: "2px solid #eee",
  paddingTop: "15px",
};

const totalLabel = {
  fontSize: "16px",
  fontWeight: "600",
};

const totalValue = {
  fontSize: "18px",
  fontWeight: "700",
  color: "#000",
};

/* Footer */
const footer = {
  marginTop: "30px",
  fontSize: "11px",
  color: "#999",
  textAlign: "center",
};

export default DownloadPdf;
